import React from 'react'
import summerCareBanner from "./../../../../../Images/Blog/Summer_Hair/Banner.png";

const SummerCareImg = () => {
  return (
    <div className="blogImg-content">
      <img src={summerCareBanner} alt="summer hair Care Banner" loading="lazy" />
    </div>
  )
}

export default SummerCareImg
